import React from 'react';
import { Dialog, DialogContent } from '../ui/dialog';
import { Button } from '../ui/button';
import { Crown, X, Clock, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TrialExpiredModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/employer/settings');
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#FFFFFF] border-[#E8EDF5] text-[#0A0F1E] sm:max-w-lg p-0 overflow-hidden">
        {/* Header with gradient */}
        <div className="relative bg-gradient-to-br from-[#0A0F1E] to-[#1B5AFF] p-8 text-center">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMiIvPjwvZz48L2c+PC9zdmc+')] opacity-30" />
          
          <div className="relative">
            <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-4">
              <Clock className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Your Free Trial Has Ended</h2>
            <p className="text-white/80">Everything you built is still here. Upgrade to keep access.</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Pricing */}
          <div className="text-center">
            <p className="text-[#5B6472] mb-2">Keep full access from</p>
            <div className="flex items-baseline justify-center gap-1">
              <span className="text-4xl font-bold text-[#0A0F1E]">$299</span>
              <span className="text-[#5B6472]">/month</span>
            </div>
          </div>

          {/* Features reminder */}
          <div className="bg-[#F5F8FF] rounded-xl p-4 border border-[#E8EDF5]">
            <p className="text-[#5B6472] text-sm mb-3">Your subscription includes:</p>
            <ul className="space-y-2">
              {[
                'Unlimited talent searches',
                'Full candidate profile access',
                'PDF exports',
                'Scheduled reviews',
                'Performance analytics',
                'Priority support'
              ].map((feature, i) => (
                <li key={i} className="flex items-center gap-2 text-[#0A0F1E] text-sm">
                  <Check className="w-4 h-4 text-[#00C9A7] flex-shrink-0" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3">
            <Button
              onClick={handleUpgrade}
              className="w-full bg-[#1B5AFF] hover:bg-[#1B5AFF]/90 text-white rounded-xl h-12 text-lg font-semibold"
              data-testid="trial-expired-upgrade-btn"
            >
              <Crown className="w-5 h-5 mr-2" />
              Upgrade Now
            </Button>
            <Button
              onClick={onClose}
              variant="ghost"
              className="w-full text-[#5B6472] hover:text-[#0A0F1E] hover:bg-[#F5F8FF] rounded-xl h-12"
              data-testid="trial-expired-later-btn"
            >
              Maybe Later
            </Button>
          </div>

          <p className="text-center text-[#5B6472] text-xs">
            Questions? Contact support@getvett.org
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TrialExpiredModal;
